module.exports = __webpack_public_path__ + "assets/imgs/logos/ohm-influmtr.43f4693a8e334aec12c1be6c5c238aa7.svg";